<template>
  <b-modal
    id="modal-lg"
    v-model="openModal"
    ok-only
    ok-title="موافق"
    centered
    size="lg"
    :title="loadingDecisions ? '' : nameDecisions"
  >
    <b-list-group>
      <b-list-group-item>
        <b-row>
          <b-col cols="3"> رقم القرار</b-col>
          <b-col cols="3"> تاريخ القرار</b-col>
          <b-col cols="4"> الجهة</b-col>
          <b-col cols="2"></b-col>
        </b-row>
      </b-list-group-item>
      <div v-if="loadingDecisions">
        <b-list-group-item v-for="n in 5" :key="n">
          <b-row>
            <b-col v-for="n in 3" :key="n" cols="3">
              <b-skeleton width="50%" height="20px"></b-skeleton
            ></b-col>

            <b-col cols="1"
              ><b-skeleton width="100%" height="20px"></b-skeleton
            ></b-col>
          </b-row>
        </b-list-group-item>
      </div>
      <template v-else>
        <b-list-group-item v-for="(item, i) in decisions" :key="i">
          <b-row>
            <b-col cols="3" class="circular_name">
              {{ item.regulation_no }}
            </b-col>
            <b-col cols="3" class="circular_name">
              {{ item.regulation_date }}</b-col
            >
            <b-col cols="4" class="circular_name"> {{ item.donor }}</b-col>

            <b-col cols="1" class="circular_download d-flex justify-end">
              <div class="circular_d">
                <router-link
                  :to="{ name: 'regulation-view', params: { id: item.id } }"
                >
                  <feather-icon class="text-success" size="18" icon="EyeIcon" />
                </router-link>
              </div>
            </b-col>
          </b-row>
        </b-list-group-item>
      </template>
      <alert
        :massage="$t('alert')"
        v-if="decisions.length == 0 && !loadingDecisions"
        class="w-100"
      ></alert>
    </b-list-group>
  </b-modal>
</template>

<script>
import {
  BRow,
  BCol,
  BModal,
  BListGroup,
  BListGroupItem,
  BSkeleton,
} from "bootstrap-vue";
import { DownloadIcon } from "vue-feather-icons";
import { mapGetters } from "vuex";
import Alert from "@/components/Alert.vue";

export default {
  props: {
    id: {
      type: Number,
    },
  },
  components: {
    BSkeleton,
    DownloadIcon,
    BRow,
    BCol,
    BModal,
    BListGroup,
    BListGroupItem,
    Alert,
  },
  data() {
    return {
      // openModal: false,
    };
  },
  watch: {
    openModal(val) {
      if (val) {
        this.$store.dispatch("NgoHome/Decisions/getDecisions", { id: this.id });
      }
    },
  },
  computed: {
    openModal: {
      set(value) {
        this.$emit("input", value);
      },
      get() {
        return this.$attrs.value;
      },
    },
    ...mapGetters("NgoHome/Decisions", [
      "decisions",
      "loadingDecisions",
      "nameDecisions",
    ]),
  },
  created() {},
};
</script>
